import { StratosCommonContent } from "../../../../modules/content/components/StratosCommonContent/StratosCommonContent";
import { StratosRichText } from "../../../../modules/content/components/StratosRichText/StratosRichText";
import { StratosSection } from "../../../../modules/content/components/StratosSection/StratosSection";
import type { IWysiwygBlockProps } from "./WysiwygBlock.props";

export const WysiwygBlock = ({
  alignment,
  anchorId,
  buttons,
  content,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: IWysiwygBlockProps) => {
  if (!content) return null;
  const hasIntro = Boolean(eyebrow || heading || description || buttons?.length);

  return (
    <StratosSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        {hasIntro ? (
          <StratosCommonContent
            alignment={alignment}
            buttons={buttons}
            description={description}
            eyebrow={eyebrow}
            heading={heading}
          />
        ) : null}
        <StratosRichText
          className="max-w-none border-t border-horizon-blue pt-8 [&_h2]:mt-14 [&_h2]:font-stratos-display [&_h2]:text-4xl [&_h2]:font-bold [&_h2]:leading-[0.95] [&_h2:first-child]:mt-0"
          content={content}
        />
      </div>
    </StratosSection>
  );
};

WysiwygBlock.displayName = "Block::WysiwygBlock";
